module.exports = __webpack_public_path__ + "img/banner.f250979f.png";